module.exports = __webpack_public_path__ + "img/rectangle_transparent.a5d1729d.svg";